import React from 'react';

interface Props {
    children: React.ReactNode;
    onClick?: () => void;
    variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
    size?: 'sm' | 'md';
    disabled?: boolean;
    type?: 'button' | 'submit';
    fullWidth?: boolean;
}

export default function Button({
    children, onClick, variant = 'primary',
    size = 'md', disabled, type = 'button', fullWidth
}: Props) {
    const base: React.CSSProperties = {
        border: 'none', borderRadius: 8,
        fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.15s',
        width: fullWidth ? '100%' : undefined,
        fontSize: size === 'sm' ? 13 : 14,
        padding: size === 'sm' ? '6px 12px' : '10px 20px',
    };

    const variants: Record<string, React.CSSProperties> = {
        primary: { background: '#1a6b3c', color: '#fff' },
        secondary: { background: '#f0f0f0', color: '#333' },
        danger: { background: '#ef4444', color: '#fff' },
        ghost: { background: 'transparent', color: '#1a6b3c',
                 border: '1.5px solid #1a6b3c' },
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            style={{ ...base, ...variants[variant] }}
        >
            {children}
        </button>
    );
}